import {IStoreEvent, IStoreEventHandler} from '../components/common/rootStore';

const eventHandlers = new Map<string, any[]>();

export function triggerGlobalEvent(type: string, eventData) {
  if (process.env.BROWSER) {
    const eventType = type as string;
    if (eventHandlers.has(eventType)) {
      eventHandlers.get(eventType).forEach((handler) => {
        handler(eventData);
      });
    }
  }
}

export function addGlobalEventHandler(type: string, handler) {
  if (process.env.BROWSER) {
    const eventType = type as string;
    if (eventHandlers.has(eventType)) {
      eventHandlers.get(eventType).push(handler);
    } else {
      eventHandlers.set(eventType, [handler]);
    }
  }
}
